import React, { Component } from "react";
// core components
import MUIDataTable from "mui-datatables";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  fetchShipSearch,
  fetchCatincompleteinfo,
  pushCatincompleteinfo
} from "../../api/portal";
import { pushLeftPanel } from "actions/dashboard";
import { pushZonaTarget, pushPoiTarget } from "actions/portal";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "components/CustomButtons/Button.jsx";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconSettings from "@material-ui/icons/Settings";
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";
import { withRouter } from "react-router-dom";

class Incompleteinfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      datatable: [],
      openAdd: false,
      category: []
    };
  }

  UNSAFE_componentWillMount() {
    fetchCatincompleteinfo()
      .then(response => {
        if (response != null) {
          this.setState({ category: response.data.results });
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  UNSAFE_componentWillReceiveProps() {
    fetchShipSearch("kn")
      .then(response => {
        if (response != null) {
          this.setState({ datatable: response.data.results });
        }
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  handleRowSelect = e => {
    // console.log(e);
    this.props.pushLeftPanel(!this.props.leftPanel);
    this.props.pushPoiTarget([e[3], e[4]]);
  };

  handleClose = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  handleChange = e => {
    const a = e.target.value.split("|");
    pushCatincompleteinfo(a[0], a[1], e.target.checked)
      .then(response => {
        fetchCatincompleteinfo()
          .then(responsex => {
            if (responsex != null) {
              this.setState({ category: responsex.data.results });
            }
          })
          .catch(error => {
            //this.props.pushToken(error);
            this.props.history.push("/pages/login#logout");
          });
      })
      .catch(error => {
        //this.props.pushToken(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  renderOpt = e => {
    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={e.deleted}
            onChange={this.handleChange}
            value={`${e.id}|${e.name}`}
            color="primary"
          />
        }
        label={e.name}
      />
    );
  };

  render() {
    const columns = [
      {
        name: "name",
        label: "Name",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "shipid",
        label: "Shipid",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "dest",
        label: "Destination",
        options: {
          filter: false,
          display: true
        }
      },
      {
        name: "latitude",
        label: "Latitude",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "longitude",
        label: "Longitude",
        options: {
          filter: false,
          display: false
        }
      }
    ];

    const options = {
      filter: false,
      search: true,
      selectableRows: false,
      print: true,
      download: true,
      responsive: "scroll",
      viewColumns: true,
      onRowClick: e => {
        this.handleRowSelect(e);
      }
    };

    return (
      <div>
        <span onClick={() => this.handleClose("openAdd", true)}>
          <Button>
            <IconSettings /> manage condition
          </Button>
        </span>
        <MUIDataTable
          data={this.state.datatable}
          columns={columns}
          options={options}
        />
        <Dialog
          maxWidth={"md"}
          open={this.state.openAdd}
          onClose={() => this.handleClose("openAdd", false)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            Incomplete field setting
          </DialogTitle>
          <DialogContent>
            <FormGroup row>{this.state.category.map(this.renderOpt)}</FormGroup>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.handleClose("openAdd", false)}
              color="default"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Incompleteinfo.propTypes = {
  pushLeftPanel: PropTypes.array,
  pushZonaTarget: PropTypes.string,
  pushPoiTarget: PropTypes.array
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader,
    rightPanel: state.rightPanel,
    leftPanel: state.leftPanel
  };
}

export default withRouter(connect(
  mapStateToProps,
  { pushLeftPanel, pushZonaTarget, pushPoiTarget }
)(Incompleteinfo));
